import { IAppState } from '../../redux';
import { IRosreestrDataState } from '../../types/reducers/rosreestrData';

export const selectCadastralFieldsMeta = (state: IAppState): IRosreestrDataState['cadastralFieldsMeta'] => {
  return state.rosreestrData.cadastralFieldsMeta;
};
